import React, { useState } from "react";
import publishReportIcon from "@assets/publish-report.svg";
import Loader from "@shared/components/Loader";

interface PublishConfirmationModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onPublish: () => void;
  reportName: string;
}

const PublishConfirmationModal: React.FC<PublishConfirmationModalProps> = ({
  isOpen,
  onCancel,
  onPublish,
  reportName,
}) => {
  const [loading, setLoading] = useState(false);

  const handleConfirmPublish = async () => {
    setLoading(true);
    await onPublish();
    setLoading(false);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg max-w-lg w-full p-6 text-center">
        <div className="flex justify-center mb-4">
          <div className=" bg-blue-100 rounded-full flex items-center justify-center">
            {/* You can replace this with an img tag if needed */}
            <img src={publishReportIcon} className="w-32" alt="" />
          </div>
        </div>
        <h2 className="text text-gray-800 mb-4">Ready to publish report?</h2>
        <p className="text-gray-800  mb-6">
          You are about to publish <strong>{reportName}</strong>, and it will be
          available for the review. Once you publish the report you can no
          longer make edits or changes.
        </p>
        <div className="flex justify-center space-x-2">
          <button
            onClick={onCancel}
            className="px-4 py-2.5  rounded text-blue-600 border border-blue-600 hover:bg-blue-50 w-full"
          >
            Cancel
          </button>
          <button
            onClick={handleConfirmPublish}
            className="px-4 py-2.5  rounded bg-blue-600 text-white hover:bg-blue-700 w-full disabled:bg-gray-400 disabled:cursor-not-allowed disabled:hover:bg-gray-400"
            disabled={loading}
          >
            {loading ? <Loader color="#fff" /> : "Publish"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PublishConfirmationModal;
